<div class="row">
  <div class="col-6">
    <ngx-select *ngIf="localService.countryCodes" [(ngModel)]="countryId" [optionValueField]="'key'" [optionTextField]="'v1'" [items]="localService.countryCodes" (select)="onCountryChanged()" [noAutoComplete]="true" [disabled]="isSetFromLogin || (countryId != '' && localService.countryCodes.length == 1) || (localService.selected && localService.selected.user != '')">
      <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
        <span [ngClass]="localService.selectedLanguageCode + '_medium'">{{option.data.v1}}</span>
      </ng-template>
    </ngx-select>
  </div>
  <div class="col-6">
    <div *ngIf="selectedItem">
      <span class="en">+{{selectedItem.v3}}</span>
      <input autocomplete="off" type="number" class="number" [ngClass]="phoneNumberNum ? 'en' : ''" [(ngModel)]="phoneNumberNum" style="width:calc(95% - 30px);text-align:left;" (keypress)="localService.isNumberOnly($event,numericConfig)" (input)="onUpdate()" placeholder="*{{localService.languageContent.common.phone_number}}" title="*{{localService.languageContent.common.phone_number}}" id="{{elementIds.ph_num}}" (keydown.enter)="onEntered()"/>
    </div>
  </div>
</div>
